(function () {
  const SECTION_SELECTOR = '.whyshift.whyshift-seen-world';
  const SLIDE_SELECTOR = '.whyshift-seen-world__slide';
  const HOSTED_VIDEO_SELECTOR = '[data-whyshift-seen-world-video]';
  const DEFERRED_EMBED_SELECTOR = '[data-whyshift-seen-world-embed-deferred]';
  const VIEWPORT_MARGIN_Y = 200;
  const VIEWPORT_MARGIN_X = 64;
  const FALLBACK_MP4S = [
    'https://cdn.shopify.com/videos/c/vp/d84850584ffa4f9ba88df21b2a0d74bd/d84850584ffa4f9ba88df21b2a0d74bd.HD-720p-1.6Mbps-86722578.mp4',
    'https://cdn.shopify.com/videos/c/vp/97873d450c4a4ba3a004f90d4cad2677/97873d450c4a4ba3a004f90d4cad2677.HD-720p-4.5Mbps-86726126.mp4',
    'https://cdn.shopify.com/videos/c/vp/e54a330b5b8540bc843d15a583268e82/e54a330b5b8540bc843d15a583268e82.HD-720p-3.0Mbps-86726128.mp4',
    'https://cdn.shopify.com/videos/c/vp/c9d7b694bb654fc0b3b2856bdc4da9ee/c9d7b694bb654fc0b3b2856bdc4da9ee.HD-720p-3.0Mbps-86726125.mp4'
  ];

  function shouldAutoplay(video) {
    return video.dataset.whyshiftSeenWorldAutoplay !== 'false';
  }

  function isNearViewport(el, marginY, marginX) {
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const vw = window.innerWidth || document.documentElement.clientWidth;

    return (
      rect.bottom >= -marginY &&
      rect.top <= vh + marginY &&
      rect.right >= -marginX &&
      rect.left <= vw + marginX
    );
  }

  function isSectionNearViewport(section) {
    return isNearViewport(section, VIEWPORT_MARGIN_Y, 0);
  }

  function activateDeferredEmbed(container) {
    if (container.dataset.whyshiftSeenWorldActivated === 'true') return;

    const template = container.querySelector('[data-whyshift-seen-world-embed-template]');
    if (!template) return;

    container.dataset.whyshiftSeenWorldActivated = 'true';
    const poster = container.querySelector('.whyshift-seen-world__video-poster');
    if (poster) poster.remove();
    container.appendChild(template.content.cloneNode(true));
  }

  function playHostedVideo(video) {
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    if (video.preload === 'none') {
      video.preload = 'metadata';
    }

    if (video.readyState < HTMLMediaElement.HAVE_METADATA) {
      video.load();
    }

    return video.play().catch(function (err) {
      debugLog('H4', 'video.play rejected', {
        name: err && err.name,
        message: err && err.message,
        readyState: video.readyState
      });
    });
  }

  function activateHostedVideo(video) {
    if (!shouldAutoplay(video)) return;

    if (video.dataset.whyshiftSeenWorldActivated === 'true') {
      if (video.paused) {
        playHostedVideo(video);
      }
      return;
    }

    video.dataset.whyshiftSeenWorldActivated = 'true';
    playHostedVideo(video);
  }

  function pauseHostedVideo(video) {
    if (!video.paused) {
      video.dataset.whyshiftWasPlaying = 'true';
      video.pause();
    }
  }

  function activateSlideMedia(slide) {
    slide.querySelectorAll(DEFERRED_EMBED_SELECTOR).forEach(activateDeferredEmbed);
    slide.querySelectorAll(HOSTED_VIDEO_SELECTOR).forEach(activateHostedVideo);
  }

  function pauseSlideMedia(slide) {
    slide.querySelectorAll(HOSTED_VIDEO_SELECTOR).forEach(pauseHostedVideo);
  }

  function isTouchDevice() {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  function updateVideoDebugState(section) {
    const videos = section.querySelectorAll(HOSTED_VIDEO_SELECTOR);
    section.dataset.wsVideoState = JSON.stringify({
      total: videos.length,
      playing: Array.from(videos).filter(function (v) { return !v.paused; }).length
    });
  }

  function scanCarouselSlides(section) {
    const track = section.querySelector('[data-whyshift-carousel-track]');
    if (!track) return false;

    const trackRect = track.getBoundingClientRect();

    section.querySelectorAll(SLIDE_SELECTOR).forEach(function (slide) {
      const rect = slide.getBoundingClientRect();
      const visible = rect.right > trackRect.left + 4 && rect.left < trackRect.right - 4;

      if (visible) {
        activateSlideMedia(slide);
      } else if (section.dataset.pauseOffscreen !== 'false' && !isTouchDevice()) {
        pauseSlideMedia(slide);
      }
    });

    updateVideoDebugState(section);
    return true;
  }

  function scanVisibleSlides(section) {
    if (scanCarouselSlides(section)) return;
    if (!isSectionNearViewport(section)) return;

    section.querySelectorAll(SLIDE_SELECTOR).forEach(function (slide) {
      if (isNearViewport(slide, VIEWPORT_MARGIN_Y, VIEWPORT_MARGIN_X)) {
        activateSlideMedia(slide);
      }
    });

    updateVideoDebugState(section);
  }

  function pollSection(section, attempts) {
    let count = 0;
    const maxAttempts = attempts || 10;

    const timer = window.setInterval(function () {
      count += 1;
      scanVisibleSlides(section);

      if (count >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, 350);
  }

  function wakeSection(section) {
    scanVisibleSlides(section);
    requestAnimationFrame(function () {
      scanVisibleSlides(section);
    });
    pollSection(section, 10);
  }

  function hydratePlaceholderSlides(section) {
    section.querySelectorAll(SLIDE_SELECTOR).forEach(function (slide, index) {
      const media = slide.querySelector('.whyshift-seen-world__media');
      if (!media) return;
      if (media.querySelector('video, img, iframe, .whyshift-seen-world__video-deferred')) return;

      const placeholder = media.querySelector('.whyshift-seen-world__placeholder');
      const src = FALLBACK_MP4S[index];
      if (!placeholder || !src) return;

      const video = document.createElement('video');
      video.className = 'whyshift-seen-world__video whyshift-seen-world__video--hosted';
      video.dataset.whyshiftSeenWorldVideo = '';
      video.dataset.whyshiftSeenWorldAutoplay = 'true';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'metadata';

      const source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);

      placeholder.replaceWith(video);
    });
  }

  function initSeenWorldSection(section) {
    if (section.dataset.whyshiftSeenWorldInit === 'true') return;
    section.dataset.whyshiftSeenWorldInit = 'true';

    hydratePlaceholderSlides(section);

    const slides = section.querySelectorAll(SLIDE_SELECTOR);
    if (!slides.length) return;

    const track = section.querySelector('[data-whyshift-carousel-track]');
    const slideObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activateSlideMedia(entry.target);
          } else if (section.dataset.pauseOffscreen !== 'false' && !isTouchDevice()) {
            pauseSlideMedia(entry.target);
          }
        });
      },
      {
        root: track || null,
        rootMargin: track ? '0px' : '200px 64px',
        threshold: track ? 0.35 : 0
      }
    );

    slides.forEach(function (slide) {
      slideObserver.observe(slide);
    });

    const sectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            wakeSection(section);
          }
        });
      },
      { root: null, rootMargin: '280px 0px', threshold: 0 }
    );
    sectionObserver.observe(section);

    if (track) {
      track.addEventListener(
        'scroll',
        function () {
          scanCarouselSlides(section);
        },
        { passive: true }
      );
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(function () {
        scanVisibleSlides(section);
      });
      resizeObserver.observe(section);
    }

    wakeSection(section);

    const unlockPlayback = function () {
      hydratePlaceholderSlides(section);
      scanCarouselSlides(section);
      scanVisibleSlides(section);
      section.querySelectorAll(HOSTED_VIDEO_SELECTOR).forEach(function (video) {
        if (shouldAutoplay(video)) playHostedVideo(video);
      });
      updateVideoDebugState(section);
    };
    section.addEventListener('touchstart', unlockPlayback, { passive: true });
    document.addEventListener('touchstart', unlockPlayback, { passive: true, once: true });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSeenWorldSection);
  }

  function debugLog(hypothesisId, message, data) {
    // #region agent log
    fetch('http://127.0.0.1:7726/ingest/cdab58e0-adbf-4a8a-9684-5bbbc8f9e3a6', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': 'c75c89' },
      body: JSON.stringify({
        sessionId: 'c75c89',
        runId: 'post-fix',
        hypothesisId: hypothesisId,
        location: 'whyshift-seen-world.js:bootstrap',
        message: message,
        data: data,
        timestamp: Date.now()
      })
    }).catch(function () {});
    // #endregion
  }

  function bootstrap() {
    const sections = document.querySelectorAll(SECTION_SELECTOR);
    const themeAsset = document.querySelector('script[src*="/assets/whyshift"],link[href*="/assets/whyshift"]');
    const assetSrc = themeAsset && (themeAsset.src || themeAsset.href) || '';
    const themeMatch = assetSrc.match(/\/t\/(\d+)\//);
    debugLog('H1-H3', 'seen-world bootstrap', {
      sectionCount: sections.length,
      placeholders: document.querySelectorAll('.whyshift-seen-world__placeholder').length,
      videos: document.querySelectorAll('.whyshift-seen-world video').length,
      themeId: themeMatch ? themeMatch[1] : null,
      viewport: { w: window.innerWidth, h: window.innerHeight },
      uaMobile: /iPhone|iPad|Android/i.test(navigator.userAgent)
    });
    initAll();
    sections.forEach(wakeSection);
    debugLog('H4', 'seen-world after wake', {
      videos: document.querySelectorAll('.whyshift-seen-world video').length,
      playing: Array.from(document.querySelectorAll('.whyshift-seen-world video')).filter((v) => !v.paused).length
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll(SECTION_SELECTOR).forEach(wakeSection);
  });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll(SECTION_SELECTOR).forEach(wakeSection);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      document.querySelectorAll(SECTION_SELECTOR).forEach(wakeSection);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target;
    const section =
      root instanceof Element && root.matches(SECTION_SELECTOR)
        ? root
        : root.querySelector?.(SECTION_SELECTOR);

    if (!section) return;

    delete section.dataset.whyshiftSeenWorldInit;
    initSeenWorldSection(section);
    wakeSection(section);
  });
})();
